import { render, staticRenderFns } from "./ReconciliationSummaryItem.vue?vue&type=template&id=0212a65a&scoped=true&"
import script from "./ReconciliationSummaryItem.vue?vue&type=script&lang=js&"
export * from "./ReconciliationSummaryItem.vue?vue&type=script&lang=js&"
import style0 from "./ReconciliationSummaryItem.vue?vue&type=style&index=0&id=0212a65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212a65a",
  null
  
)

export default component.exports